import { createSlice } from '@reduxjs/toolkit';
import { getScopesList } from './thunk';

export const initialState = {
	error: '',
	success: '',
	scopesList: [],
	scopesListSelect: [],
};

const ScopesSlice = createSlice({
	name: 'Scopes',
	initialState,
	reducers: {
		ScopesSuccess(state, action) {
			state.success = action.payload.status;
			state.user = action.payload.data;
		},
		ScopesError(state, action) {
			state.error = action.payload;
		},
		editScopesChange(state) {
			state = { ...state };
		},
		resetScopesFlagChange(state) {
			state.success = null;
		},
	},
	extraReducers: builder => {
		builder.addCase(getScopesList.fulfilled, (state, action) => {
			state.scopesList = action.payload;
			state.scopesListSelect = action.payload.map(item => ({
				item: item,
				value: item._id,
				label: item.name,
			}));
			state.success = true;
		});
		builder.addCase(getScopesList.pending, (state, action) => {
			state.success = true;
		});
		builder.addCase(getScopesList.rejected, (state, action) => {
			state.user = {};
			state.success = true;
		});
	},
});

export const {
	ScopesSuccess,
	ScopesError,
	editScopesChange,
	resetScopesFlagChange,
} = ScopesSlice.actions;

export default ScopesSlice.reducer;
